module.exports = __webpack_public_path__ + "static/media/team2.ddd51a83.jpg";